module.exports = __webpack_public_path__ + "img/lolc_mobile.c83d7e74.png";